import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCHTMLTextEditor, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import IOrgChartMissionsAndPremisesRef, { IMissionAndPremise } from "./interface";

const MissionAndPremisesModal: React.ForwardRefRenderFunction<IOrgChartMissionsAndPremisesRef> = (_, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();

	const modalMissionAndPremises = useRef<RCCRefModalProps>(null);
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [oktbb001, setOktbb001] = useState<IMissionAndPremise>({} as IMissionAndPremise);
	const { control } = useForm();
	const openModalMissionAndPremises = useCallback(async (id: number, titleOkr: string) => {
		try{
			setLoading(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/SelectMissionAndPremises",
				urlParameters: {
					id
				}
			});

			setOktbb001(data);
			setLoading(false);
			setSubtitle(`OKR: ${titleOkr}`);
			modalMissionAndPremises.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar informações de missão e premissas do OKR"), addToast);
		}
	}, []);

	useImperativeHandle(ref, () => ({
		openModalMissionAndPremises
	}));

	return (
		<>
			
			<Modal
				ref={modalMissionAndPremises}
				header={{
					title: translate("Missão e Premissas"),
					subtitle,
					icon: {
						name: "list"
					}
				}}
				footer={{
					showSaveButton: false,
					buttonLoadingText: "",
					saveButtonText: "",
					cancelButtonText:translate("Cancelar")
				}}
				styleInline={ModalSide}
			>
				<RCCHTMLTextEditor
					name="oka001Missao"
					label={translate("Missão")}
					control={control}
					disabled
					defaultValue={oktbb001.oka001Missao || ""}
				/>
				<RCCHTMLTextEditor
					name="oka001Premissas"
					label={translate("Premissas")}
					control={control}
					disabled
					defaultValue={oktbb001.oka001Premissas || ""}
				/>
			</Modal>
		</>
	);
};

export default forwardRef(MissionAndPremisesModal);
